"use client";
import { jsx } from "react/jsx-runtime";
import ListBoxProvider from "./ListBoxContext";
import ListBoxInternal from "./ListBoxInternal";
const ListBox = (props) => {
  const {
    children,
    multiple,
    value,
    trigger,
    ariaLabel,
    domFocus,
    onChange,
    open,
    footer,
    prefix,
    className,
    position,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsx(ListBoxProvider, { multiple, value, children: /* @__PURE__ */ jsx(
    ListBoxInternal,
    {
      multiple,
      value,
      trigger,
      ariaLabel,
      domFocus,
      onChange,
      open,
      footer,
      prefix,
      className,
      position,
      ...otherProps,
      children
    }
  ) });
};
ListBox.displayName = "ListBox";
var ListBox_default = ListBox;
export {
  ListBox_default as default
};
